import * as z from 'zod';

import { ColumnEnumMappingId, ColumnMappingId, CompanyId, FileImportId } from '../BrandedIds';
import { ImportType } from '../loan/LoanImport';

/** Mirrors the `ColumnType` Prisma enum on `column_mappings.column_type`. */
export const ColumnType = z.enum(['STRING', 'BOOLEAN', 'ENUM']);
export type ColumnType = z.infer<typeof ColumnType>;

export interface FileImport {
  id: FileImportId;
  companyId: CompanyId;
  importType: ImportType;
  s3Url: string;
  fileName: string;
  sheetIndex: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface ColumnMapping {
  id: ColumnMappingId;
  companyId: CompanyId;
  importType: ImportType;
  spreadsheetHeader: string;
  zodPath?: string;
  columnType: ColumnType;
  skipMapping: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface ColumnEnumMapping {
  id: ColumnEnumMappingId;
  columnMappingId: ColumnMappingId;
  spreadsheetValue: string;
  enumValue: string;
  skipMapping: boolean;
  createdAt: Date;
  updatedAt: Date;
}

/** `ColumnMapping` loaded together with its enum mappings (for upsert-time dispatch and process-time lookup). */
export interface ColumnMappingWithEnums extends ColumnMapping {
  columnEnumMappings: ColumnEnumMapping[];
}

/** Enum mapping row as received from the client — ids are generated during upsert. */
export interface ColumnEnumMappingInput {
  spreadsheetValue: string;
  enumValue: string;
  skipMapping: boolean;
}

/** Column mapping row as received from the client — ids are generated during upsert. */
export interface ColumnMappingInput {
  spreadsheetHeader: string;
  zodPath: string | null;
  columnType: ColumnType;
  skipMapping: boolean;
  enumMappings?: ColumnEnumMappingInput[];
}
